import { FlexRow } from '@gorila-shared-ui/components';
import { Checkbox } from 'baseui/checkbox';
import { useEffect, useState } from 'react';
import { areEqual } from 'react-window';

type Props = {
  enabledDays?: Array<0 | 1 | 2 | 3 | 4 | 5 | 6>;
  onChange: (days: boolean[]) => void;
};
export function DaysPicker({ enabledDays, onChange }: Props) {
  const [days, setDays] = useState([false, false, false, false, false, false, false]);
  const defaultDaysValue = [false, false, false, false, false, false, false];

  useEffect(() => {
    if (!enabledDays || !enabledDays.length) {
      if (areEqual(days, defaultDaysValue)) return;
      setDays([false, false, false, false, false, false, false]);
      onChange(days);
      return;
    }
    // remove possible duplicates
    const nonRepeatingDays: number[] = enabledDays.filter((item, index) => {
      return enabledDays.indexOf(item) === index;
    });
    if (nonRepeatingDays.length > 7) return;
    setDays((prev) => {
      return prev.map((day, index) => {
        return nonRepeatingDays.includes(index);
      });
    });
  }, [enabledDays]);

  useEffect(() => {
    onChange(days);
  }, [days]);

  const onToggleDays = (day: number, isEnabled: boolean) => {
    setDays((d) => {
      d[day] = isEnabled;
      return [...d];
    });
  };

  return (
    <FlexRow>
      <Checkbox
        checked={days[0]}
        onChange={(e) => onToggleDays(0, e.target.checked)}
        labelPlacement="top"
      >
        Lu
      </Checkbox>
      <Checkbox
        checked={days[1]}
        onChange={(e) => onToggleDays(1, e.target.checked)}
        labelPlacement="top"
      >
        Ma
      </Checkbox>
      <Checkbox
        checked={days[2]}
        onChange={(e) => onToggleDays(2, e.target.checked)}
        labelPlacement="top"
      >
        Mi
      </Checkbox>
      <Checkbox
        checked={days[3]}
        onChange={(e) => onToggleDays(3, e.target.checked)}
        labelPlacement="top"
      >
        Ju
      </Checkbox>
      <Checkbox
        checked={days[4]}
        onChange={(e) => onToggleDays(4, e.target.checked)}
        labelPlacement="top"
      >
        Vi
      </Checkbox>
      <Checkbox
        checked={days[5]}
        onChange={(e) => onToggleDays(5, e.target.checked)}
        labelPlacement="top"
      >
        Sa
      </Checkbox>
      <Checkbox
        checked={days[6]}
        onChange={(e) => onToggleDays(6, e.target.checked)}
        labelPlacement="top"
      >
        Do
      </Checkbox>
    </FlexRow>
  );
}
